import { ProductClickedEventParams } from "../events/product/ProductClickedEvent";
import { ProductAddedToCartEventParams } from "../events/product/ProductAddedToCartEvent";
import { getCommonParams } from "./CommonParams";
import { mapProductTrackingData } from "./ProductObjectMapper";
import { ProductViewedEventParams } from "../events/product/ProductViewedEvent";
import routeController from '../../../routes'

export const createProductClickedEventParams = (
    productObj: any,
    inventoryStatus?: string | null
): ProductClickedEventParams => {
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: 'grocery',
        EVENT_CATEGORY: 'grocery',
        PRODUCTS: [mapProductTrackingData(productObj, inventoryStatus)],
    }
}

export const createProductAddedToCartEventParams = (
    productObj: any,
    inventoryStatus?: string | null,
    quantity?: number | null,
    index?: string | null,
    queryId?: string | null
): ProductAddedToCartEventParams => {
    const { pathname } = window.location;
    const match = routeController.match(pathname);
    const isPDP = match.route?.name === 'product';
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: 'grocery',
        EVENT_CATEGORY: 'grocery',
        FULFILMENT_CHANNEL: 'online',
        CHECKOUT_FLOW: 'e-commerce',
        PRODUCTS: [mapProductTrackingData(productObj, inventoryStatus, quantity ?? 1)],
        INDEX: index ?? null,
        EVENT_TYPE: isPDP ? 'conversion' : 'conversion || click',
        EVENT_SUBTYPE: 'addToCart',
        QUERY_ID: queryId ?? null,
    };
}

export const createProductViewedEventParams = (
    products: Array<{ swimlaneTitle?: string; [key: string]: any }>
): ProductViewedEventParams => {
    const screenSection = products?.[0]?.swimlaneTitle ?? null;
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: 'grocery',
        PRODUCTS: products,
        SCREEN_SECTION: screenSection,
    }
}